import styling from '../../services/styling';

export const ANIMATION_DURATION = parseInt(styling.speeds.walk, 10) / 1000;
